<template>
  <div>
    <header
      class="header flex md:block sm:py-4 sm:px-4 py-6 text-gray-100  px-16 sm:justify-center justify-between sm:mx-auto  shadow-md"
    >
      <h1
        class="text-5xl sm:text-3xl font-black font-headingFont relative p-3 mt-3"
      >
        Simi.Codes
      </h1>
    </header>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.header {
  background: var(--color-primary);
}
</style>
